import bg from './bg';
import fr from './fr';

export const translations = {
	fr,
	bg
};
export default translations;
